var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18.83,
    viewBox: "0 0 22 18.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13295",
    "data-name": "Group 13295",
    transform: "translate(-15955.999 -7142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(15963.414 7147.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M7.13,7.079a1.614,1.614,0,0,1-.348,1.042,1.043,1.043,0,0,1-.838.434H1.186a1.043,1.043,0,0,1-.838-.434A1.614,1.614,0,0,1,0,7.079a8,8,0,0,1,.047-.894,4.8,4.8,0,0,1,.175-.847,2.819,2.819,0,0,1,.326-.73,1.559,1.559,0,0,1,.524-.5,1.447,1.447,0,0,1,.749-.192,2.407,2.407,0,0,0,1.743.713,2.407,2.407,0,0,0,1.743-.713,1.447,1.447,0,0,1,.749.192,1.559,1.559,0,0,1,.524.5,2.819,2.819,0,0,1,.326.73,4.8,4.8,0,0,1,.175.847A8,8,0,0,1,7.13,7.079ZM5.7,2.139a2.061,2.061,0,0,1-.627,1.512,2.061,2.061,0,0,1-1.512.627,2.061,2.061,0,0,1-1.512-.627,2.061,2.061,0,0,1-.627-1.512A2.061,2.061,0,0,1,2.053.627,2.061,2.061,0,0,1,3.565,0,2.061,2.061,0,0,1,5.077.627,2.061,2.061,0,0,1,5.7,2.139Z",
    transform: "translate(0 0)",
    fill: "#74613c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M6.77,18.91h0L4.024,16.164,6.77,13.45v2.233h.466a6.03,6.03,0,0,0,4.406-1.826A6.03,6.03,0,0,0,13.468,9.45a6.247,6.247,0,0,0-.577-2.608l.729-.729a7.2,7.2,0,0,1,.808,3.336,6.916,6.916,0,0,1-2.116,5.121,6.864,6.864,0,0,1-5.076,2.116H6.77V18.91ZM.813,12.8h0A7.2,7.2,0,0,1,0,9.45,6.916,6.916,0,0,1,2.116,4.33,6.916,6.916,0,0,1,7.236,2.214H7.7V0l2.705,2.737L7.7,5.442V3.219H7.236A6.03,6.03,0,0,0,2.83,5.044,6.03,6.03,0,0,0,1,9.45a6.13,6.13,0,0,0,.572,2.605l-.764.74Z",
    transform: "matrix(0.259, 0.966, -0.966, 0.259, 15974.265, 7142)",
    fill: "#74613c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecover);
export default __webpack_public_path__ + "static/media/recover.ee15dab3b6af0529570a3f06a8bfab8e.svg";
export { ForwardRef as ReactComponent };